export function canAccess(permission: string) {
  const permissions: string = localStorage.getItem("permissions") ?? "";
  const permissionsArray = permissions.split(",");
  return permissionsArray.find((x) => x === permission) !== undefined;
}
